import { image_404 } from '@assets/images';
import { NavLink, useLoaderData, useNavigate } from '@remix-run/react';
import Header from './header';
import HeaderMobile from './header-mobile';
import { LoaderFunctionArgs } from '@remix-run/node';
import { HeaderProps } from '@models/ui';
import { mixpanelService } from '@utilities';

export default function FourOFour() {
  const loaderData = useLoaderData<typeof loader>();
  const headerProps: HeaderProps = {
    isLoggedIn: loaderData.isAuthenticated,
    position: 'header',
    customerName: loaderData.user?.name ?? '',
    customerImageUrl: loaderData.user?.profilePic ?? '',
    showManageEvaluations: true,
    isSubscribed: loaderData.user?.isSubscribed ?? false,
  };

  return <>{!loaderData.isMobile ? <DesktopComponent headerProps={headerProps} /> : <MobileComponent headerProps={headerProps} />}</>;
}

const DesktopComponent = ({ headerProps }: { headerProps: HeaderProps }) => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1); // Go back one step in history
  };

  const onExploreAllClick = () => {
    let userStatus = 'visitor';
    if (headerProps.isLoggedIn) {
      userStatus = 'registered';
    }
    if (headerProps.isSubscribed) {
      userStatus = 'subscriber';
    }
    mixpanelService.track('video_library_home_loads', {
      source: '404_page',
      user_status: userStatus,
    });
  };

  return (
    <>
      <Header headerProps={headerProps} />
      <div className="four-desktop-div">
        <div className="content-div">
          <img src={image_404} alt="image_404" className="translate-x-16 translate-y-2" />
          <div className="top-section -translate-y-24">
            <p className="header">Oops! This page got lost in the frameworks!</p>
            <p className="sub-header">Looks like the page you&apos;re looking for isn&apos;t available. But don&apos;t worry, we&apos;ve got other places for you to visit:</p>
          </div>
          <div className="bottom-section -translate-y-24">
            <button className="link" onClick={handleBackClick}>
              Head back to where you came from
            </button>
            <NavLink to="/" className="link">
              Visit the home page
            </NavLink>
            <NavLink to="/knowledge-hub/resources/videos" className="link" onClick={onExploreAllClick}>
              Explore all videos
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

const MobileComponent = ({ headerProps }: { headerProps: HeaderProps }) => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1); // Go back one step in history
  };

  const onExploreAllClick = () => {
    let userStatus = 'visitor';
    if (headerProps.isLoggedIn) {
      userStatus = 'registered';
    }
    if (headerProps.isSubscribed) {
      userStatus = 'subscriber';
    }
    mixpanelService.track('video_library_home_loads', {
      source: '404_page',
      user_status: userStatus,
    });
  };

  return (
    <>
      <HeaderMobile headerProps={headerProps} />
      <div className="four-mobile-div">
        <div className="content-div">
          <img src={image_404} alt="image_404" className="image translate-x-9 translate-y-2" />
          <div className="top-section -translate-y-16">
            <p className="header">Oops! This page got lost in the frameworks!</p>
            <p className="sub-header">Looks like the page you&apos;re looking for isn&apos;t available. But don&apos;t worry, we&apos;ve got other places for you to visit:</p>
          </div>
          <div className="bottom-section -translate-y-16">
            <button className="link" onClick={handleBackClick}>
              Head back to where you came from
            </button>
            <NavLink to="/" className="link">
              Visit the home page
            </NavLink>
            <NavLink to="/knowledge-hub" className="link" onClick={onExploreAllClick}>
              Explore all videos
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export async function loader({ context }: LoaderFunctionArgs) {
  return { ...context.clientContext };
}
